// extracted by mini-css-extract-plugin
export default {"searchForm":"bx_gN"};